// 容器分类页面请求
import Request from "./request";
import consts from "@/consts.js";

// 容器分类管理
async function fetch(data) {
  return Request("get", "api/container-categories/", data);
}
// 删除数据
async function del(id){
  return Request("delete", "api/container-categories/delete/" + id);
}

// 编辑或新建（有id为编辑，没有id为新建）
async function save(id,data) {
  if (id) {
      return Request('post', "api/container-categories/edit?id=" + id, data);
  } else {
      return Request('post', "api/container-categories/add" , data);
  }
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/container-categories/" + id);
}

async function fetchAll(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return fetch(data);
}

async function fetchAllForSelect(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request('get', "api/container-categories/select", data, false, false, true);
}

export default {
  fetch,
  fetchOne,
  fetchAll,
  fetchAllForSelect,
  del,
  save
};
